import { ThemeModule } from '../../front/lib/ThemeModule';
import { createGenericModal } from '../../front/components';
import { ContactForm } from '../ContactForm/ContactForm';
export class ContactFormButton extends ThemeModule {
    constructor() {
        super(...arguments);
        this.textVariationsTimeout = null;
        this.currentTextVariationIdx = 0;
    }
    init() {
        document.body.appendChild(this.root);
        const getContactFormDOM = ContactForm.createLazyContactFormDOMFn(this.getElementById('modalContent'));
        document.addEventListener('click', e => {
            var _a;
            if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('[data-contact-form-button="open"]')) {
                const modal = createGenericModal({
                    bodyDOM: getContactFormDOM(),
                });
                modal.show();
            }
        });
        if (this.json.text_variations.length > 1) {
            this.scheduleNextTextVariation();
        }
    }
    scheduleNextTextVariation() {
        this.textVariationsTimeout = window.setTimeout(() => {
            this.applyRandomTextVariation().then(() => this.scheduleNextTextVariation());
        }, (Math.random() * 5000) + 5000);
    }
    async applyRandomTextVariation() {
        var _a, _b;
        const otherIdxs = this.json.text_variations.map((_, i) => i).filter(i => i !== this.currentTextVariationIdx);
        otherIdxs.sort(() => Math.random() - 0.5);
        this.currentTextVariationIdx = otherIdxs[0];
        const text = this.json.text_variations[this.currentTextVariationIdx];
        const spanEls = this.querySelectorAll('.openBtn .themeButton-title span');
        const idle = () => new Promise(resolve => setTimeout(resolve, 100));
        for (let i = 0; i < spanEls.length; i++) {
            spanEls[i].classList.add('is--fadingOut');
            (_a = spanEls[i + 1]) === null || _a === void 0 ? void 0 : _a.classList.add('is--fadingOut');
            (_b = spanEls[i + 2]) === null || _b === void 0 ? void 0 : _b.classList.add('is--fadingOut');
            await idle();
            if (text[i]) {
                spanEls[i].textContent = text[i];
                spanEls[i].classList.remove('is--fadingOut');
            }
            else {
                spanEls[i].parentElement.removeChild(spanEls[i]);
            }
        }
        if (text.length - spanEls.length > 0) {
            for (let i = spanEls.length; i < text.length; i++) {
                const span = document.createElement('span');
                span.textContent = text[i];
                spanEls[0].parentElement.appendChild(span);
                await idle();
            }
        }
    }
}
